module.exports = "\r\n.martop20{\r\n    margin-top: 20px;\r\n}\r\n.row{\r\n    padding:10px 0px 0px;\r\n}\r\n.container-fluid .row:nth-child(even){\r\n    background: #f3f3f3;\r\n}\r\n.form-group label{\r\n    color: #0000ff;\r\n    width: 99%;\r\n    font-size: 18px;\r\n    font-weight: normal\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/arm-details/arm-details-form/arm-details-form.component.css
// module id = ./src/app/pages/functions/arm-details/arm-details-form/arm-details-form.component.css
// module chunks = main